import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";

function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);

  if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }

  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

import { useState, useEffect, useReducer, useCallback } from 'react';
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};

var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }

  if (__getOwnPropSymbols) {
    for (var _iterator = _createForOfIteratorHelperLoose(__getOwnPropSymbols(b)), _step; !(_step = _iterator()).done;) {
      var prop = _step.value;
      if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    }
  }

  return a;
};

var __spreadProps = function __spreadProps(a, b) {
  return __defProps(a, __getOwnPropDescs(b));
};

var LazyloadActions =
/* @__PURE__ */
function (LazyloadActions2) {
  LazyloadActions2["LOAD_MORE"] = "LOAD_MORE";
  return LazyloadActions2;
}(LazyloadActions || {});

var lazyloadReducer = function lazyloadReducer(state, action) {
  switch (action.type) {
    case "LOAD_MORE"
    /* LOAD_MORE */
    :
      return __spreadProps(__spreadValues({}, state), {
        loaded: state.loaded + 1
      });

    default:
      return state;
  }
};

var useLazyload = function useLazyload(observerRef, config) {
  var _useState = useState(false),
      initialized = _useState[0],
      setInitialized = _useState[1];

  var _useState2 = useState(),
      observer = _useState2[0],
      setObserver = _useState2[1];

  var _useState3 = useState(0),
      maxObservation = _useState3[0],
      setMaxObservation = _useState3[1];

  useEffect(function () {
    if (config == null ? void 0 : config.maxObservation) {
      setMaxObservation(config.maxObservation);
    }
  }, [config, setMaxObservation]);
  var firstload = (config == null ? void 0 : config.firstload) ? config.firstload : 0;

  var _useReducer = useReducer(lazyloadReducer, {
    loaded: firstload
  }),
      lazyloadState = _useReducer[0],
      lazyloadDispatch = _useReducer[1];

  var scrollObserver = useCallback(function (node) {
    if (node === null) {
      return;
    }

    var observationCount = maxObservation;
    return new IntersectionObserver(function (entries, self) {
      entries.forEach(function (entry) {
        if (entry.intersectionRatio > 0) {
          if (observationCount === 0) {
            self.unobserve(entry.target);
          } else {
            lazyloadDispatch({
              type: "LOAD_MORE"
              /* LOAD_MORE */

            });
            observationCount--;
          }
        }
      });
      return self;
    });
  }, [lazyloadDispatch, maxObservation]);
  useEffect(function () {
    if (initialized && !observer && (observerRef == null ? void 0 : observerRef.current)) {
      setObserver(scrollObserver(observerRef.current));
    }
  }, [initialized, observerRef, observer, scrollObserver]);
  useEffect(function () {
    if (observer && (observerRef == null ? void 0 : observerRef.current)) {
      observer == null ? void 0 : observer.observe(observerRef.current);
    }

    return function () {
      observer == null ? void 0 : observer.disconnect();
    };
  }, [observerRef, observer]);

  var lazyloadInit = function lazyloadInit() {
    if (!("IntersectionObserver" in window)) {
      return false;
    }

    setInitialized(true);
    return true;
  };

  return {
    init: function init() {
      return lazyloadInit();
    },
    more: function more() {
      lazyloadDispatch({
        type: "LOAD_MORE"
        /* LOAD_MORE */

      });
    },
    loaded: function loaded() {
      return lazyloadState.loaded;
    }
  };
};

export { LazyloadActions, useLazyload };